import { MessageCircle } from "lucide-react";
import { SITE } from "../lib/site";

export const FloatingButtons = () => (
  <div
    className="fixed right-5 z-50"
    style={{ bottom: "calc(1.25rem + env(safe-area-inset-bottom, 0px))" }}
  >
    <a
      data-testid="floating-whatsapp-button"
      href={`https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(SITE.whatsappMessage)}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="whatsapp-pulse w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center text-white hover:scale-105 transition-transform duration-200"
    >
      <MessageCircle size={26} className="fill-white" />
    </a>
  </div>
);
